import { render, staticRenderFns } from "./RoutePointList.vue?vue&type=template&id=48b9b994&"
import script from "./RoutePointList.vue?vue&type=script&lang=js&"
export * from "./RoutePointList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports